import { Home } from "lucide-react";

type Props = {
  total: number;
  currentIndex: number;
  onDotClick: (index: number) => void;
  onHomeClick: () => void;
};

const SlideDots = ({ total, currentIndex, onDotClick, onHomeClick }: Props) => {
  const railStyle = {
    borderColor: "var(--surface-border)",
    background: "color-mix(in srgb, black 34%, transparent)",
    bottom: "max(1rem, env(safe-area-inset-bottom))",
  };
  return (
    <div className="absolute inset-x-0 bottom-3 z-50 flex justify-center px-3 sm:inset-x-auto sm:bottom-auto sm:right-6 sm:top-1/2 sm:-translate-y-1/2 sm:px-0">
      <div
        className="flex w-full max-w-sm items-center justify-between gap-2 rounded-full border px-3 py-2 shadow-[0_20px_70px_rgba(0,0,0,0.28)] backdrop-blur-2xl sm:w-auto sm:max-w-none sm:flex-col sm:justify-center sm:rounded-[2rem] sm:px-2 sm:py-3"
        style={railStyle}
      >
        <div className="text-[0.65rem] font-semibold uppercase tracking-[0.22em] text-[color:var(--text-soft)] sm:hidden">
          {currentIndex + 1} / {total}
        </div>
        <button
          onClick={onHomeClick}
          className={`hidden h-10 w-10 items-center justify-center rounded-full transition sm:flex ${
            currentIndex === -1
              ? "bg-[color:var(--accent)] text-[#0d1a19]"
              : "bg-white/10 text-[color:var(--text)] hover:bg-white/16"
          }`}
          aria-label="Go to intro"
        >
          <Home size={16} />
        </button>

        <div className="flex items-center gap-1 sm:flex-col sm:gap-2">
          {[...Array(total)].map((_, i) => (
            <button
              key={i}
              onClick={() => onDotClick(i)}
              className={`relative flex h-7 w-7 items-center justify-center rounded-full transition sm:h-10 sm:w-10 ${
                i === currentIndex
                  ? "bg-white/14"
                  : "bg-transparent hover:bg-white/8"
              }`}
              aria-label={`Go to slide ${i + 1}`}
            >
              <span
                className={`block rounded-full transition-all ${
                  i === currentIndex
                    ? "h-2.5 w-2.5 bg-[color:var(--accent)] shadow-[0_0_18px_rgba(247,196,101,0.8)] sm:h-3.5 sm:w-3.5"
                    : "h-2 w-2 bg-[color:var(--text-soft)] sm:h-2.5 sm:w-2.5"
                }`}
              />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SlideDots;
